import { localStore, cartActions } from '../../services';
import { getUserAssignments, getAccessoriesExtended } from '../../util';

const urlIsIntegrated = window.location.href.includes('?');
const isIntegrated = () => window.parent !== window || urlIsIntegrated;

const multiCartStore = keyProvider => ( {
  add( item, quantity = 1, parameters, parent,noteByUser='' ,state) {
    if ( Array.isArray( item ) ) {
      const parentKey = keyProvider( { ...item[0], parameters } );
      // multiple products
      let currentState = state;
      for ( let p of item ) {
        currentState = this.add( p, quantity, parameters, parentKey,item.noteByUser || noteByUser, currentState );
      }
      return currentState;
    }
    const key = keyProvider( { ...item, parameters, parent } );
    if ( (state[key] || item.cartID)  ) {
      if(item.cartID){
        //let resultState = { ...state, [key]: undefined, lastUpdated: key };
        let resultState = {};
        let keyMatched;
        Object.values(state).forEach(value=>{if(typeof(value)=='object' && !Array.isArray(value)){if(value['product']['cartID']==item.cartID){resultState={...state,lastUpdated:key};keyMatched=Object.keys(state).find(key=>state[key]==value )}}})    
        const finalKey = keyMatched && keyMatched.startsWith('_')?key:keyMatched.slice(0,keyMatched.indexOf('_')).concat(key)
        resultState.lastUpdated=finalKey;
        resultState[keyMatched].product=item;
        resultState.stack.forEach((s,i)=>{if(s==keyMatched){
          delete resultState.stack[i]; 
          resultState.stack.splice(i,0,finalKey)              
        }});
        resultState.stack=resultState.stack.filter(s=>s.length);
        const product=resultState[keyMatched];
        delete resultState[keyMatched];
        resultState[finalKey]=product;
        return resultState;
        }
      // increase quantity
      return { ...state, [key]: { ...state[key], product: { ...state[key].product,noteByUser:noteByUser?noteByUser:'' },quantity: state[key].quantity + quantity }, lastUpdated: key };
    }
    // keep last added in 'stack'
    return { ...state, [key]: { product: { ...item,noteByUser:noteByUser,cartID:state.stack?state.stack.length+1:1,clonedIdx:item.clonedIdx  }, parameters, quantity, parent }, stack: [...state.stack || [], key], lastUpdated: key };
  },
  setQuantity( item, quantity, state ) {
    if ( quantity <= 0 ) {
      // no negative quantities
      return this.remove( typeof(item.product) === "object" ? item.product : item, state );
    }
    const key = keyProvider( typeof(item.product) === "object" ? item.product : item );
    if ( !state[key] ) {
      console.warn( `didn't find a quantity to update for ${key}` );
      // not found, so no update
      return state;
    }
    let currentState = { ...state, [key]: { ...state[key], quantity }, lastUpdated: key };
    const children = Object.values( state ).filter( f => f.parent === key );
    for (let child of children) {
      currentState = this.setQuantity( child, quantity, currentState );
    }
    return currentState;
  },
  remove( item, state ) {
    const key = keyProvider( typeof(item.product) === "object" ? item.product : item );
    if ( !state[key] ) {
      return state;
    }
    let resultState = { ...state, [key]: undefined, lastUpdated: undefined };
    delete resultState[key];
    delete resultState['lastUpdated'];
    const children = Object.values( state ).filter( f => f.parent === key );
    for ( let child of children ) {
      resultState = this.remove( child, resultState );
    }
    let stackKeyIndex = resultState.stack.findIndex( v => v === key );
    if ( stackKeyIndex >= 0 ) {
      resultState.stack = [...resultState.stack.slice( 0, stackKeyIndex ), ...resultState.stack.slice( stackKeyIndex + 1 )];
    }
    return resultState;
  },
  update( oldItem, newItem, state ) {
    return this.add( newItem, oldItem.amount, oldItem.parameters, '',oldItem.noteByUser,  state  );
  },
  setNote (item,note,state){
    const key = keyProvider( typeof(item.product) === "object" ? item.product : item );
    if ( state[key] ) {
      return { ...state, [key]: {...state[key],product: { ...state[key].product, noteByUser: note} ,noteByUser:note}, lastUpdated: key };     

    }
    let currentState = { ...state, [key]: { ...state[key], noteByUser:note }, lastUpdated: key };
    return currentState;

  }
} );

function createItemUuid( item ) {
  if ( !item ) {
    return '';
  } 

  const clonedIdx = item.clonedIdx || '';
  const modelToLoad = item.modelToLoad || '';
  let configuration = '';
  let additionalconfiguration = '';

  if( item.configuration ) {
    const assignments = getUserAssignments( item.configuration ).orderBy( a => a.key );
    configuration = assignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
  }
  if( item.additionalProducts && item.additionalProducts.length > 0 ){
    let mainPartName, accessoryName;
    //products > 1, get the assignments and name from item.additionalProducts
    if( item.additionalProducts.length > 1 ) {
      mainPartName = item.additionalProducts[0].name;
      accessoryName = item.additionalProducts[1].name;
      const assignments = getUserAssignments( item.additionalProducts[0].configuration ).orderBy( a => a.key );
      configuration = assignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
    }
    if( item.additionalProducts[0].configuration ) {
      let userAssignments = [];
      if( item.additionalProducts.length > 1 && item.additionalProducts[0].additionalProducts[0].configuration ){
        userAssignments = getUserAssignments( item.additionalProducts[0].additionalProducts[0].configuration );
      }
      else if( item.additionalProducts.length === 1 ){
        userAssignments = getUserAssignments( item.additionalProducts[0].configuration );
      }
      const additionalassignments = userAssignments.orderBy( a => a.key );
      additionalconfiguration = additionalassignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
    }
    return `${clonedIdx}_${mainPartName || item.name}_${configuration}_${modelToLoad}_MP+FP_${accessoryName || item.additionalProducts[0].name}_${additionalconfiguration}_${item.deliveryOption}`;
  }
  if( item.looseadditionalProduct && item.looseadditionalProduct.length>0 ){
    if( item.looseadditionalProduct[0].configuration ) {
      const additionalassignments = getUserAssignments( item.looseadditionalProduct[0].configuration ).orderBy( a => a.key );
      additionalconfiguration = additionalassignments.select( ass => `${ass.key}-${ass.value}` ).join( '|' );
    }
    return `${clonedIdx}_${item.name}_${configuration}_${modelToLoad}_MP+FP_${item.looseadditionalProduct[0].name}_${additionalconfiguration}_${item.deliveryOption}`;
  }
  
  return `${clonedIdx}_${item.name}_${configuration}_${modelToLoad}_${item.deliveryOption}`;
}

function setItem( state ) {
  if ( !isIntegrated() ) {   
    try
    {
      let productList = [];
      state && state.stack?.forEach((stackKey, index) => {
        if( stackKey != 'lastUpdated' && stackKey != 'stack'){
          let product = state[stackKey].product;
          let looseAccessories=product.looseadditionalProduct && getAccessoriesExtended( product.looseadditionalProduct[0]?.configuration, [], true, true, product.looseadditionalProduct[0]?.amount ).map(c=>{return {...c,looseacc:true}});
          let bomItemsNotConfigured=[];
          let importAccessories=getAccessoriesExtended( product.configuration, product.importAccessories, true, true, state[stackKey].quantity )
          importAccessories.forEach(acc=>bomItemsNotConfigured.push
            ({"name":acc.accessoryCode,
              "value": acc.accessoryCode,
              "looseacc": acc.looseacc,
              "configuredAcc": acc.configuredAcc || product.bom && product.bom.find(p=>p.name===acc.accessoryCode)?.configuredAcc
            }))
            looseAccessories && looseAccessories.forEach(acc=>!bomItemsNotConfigured.any(b=>b.name==acc.accessoryCode) && bomItemsNotConfigured.push(
            {
              "name":acc.accessoryCode,
              "value": acc.accessoryCode,
              "looseacc": acc.looseacc 
            }
          ))
          let count=0;
          importAccessories.forEach(acc=>{if(acc.looseacc){looseAccessories.forEach(loose=>{if(loose.accessoryCode
            ==acc.accessoryCode){count+=1;}})}})

          const hasAdditionalProducts = (product.additionalProducts && product.additionalProducts.length > 0) || (product.looseadditionalProduct && product.looseadditionalProduct.length>0) ;

          // if product has no additionalProducts then combinationId will be -1
          //const combinationId = hasAdditionalProducts ? index : -1;

          product.name && productList.push({
            product: product.name,
            quantity: state[stackKey].quantity,
            description:product.description,
            productLink:product.productLink,
            importAccessories: product.importAccessories?product.importAccessories:looseAccessories && looseAccessories.length>0 && count==0?getAccessoriesExtended( product.configuration, product.importAccessories, true, true, state[stackKey].quantity ).concat(looseAccessories):getAccessoriesExtended( product.configuration, product.importAccessories, true, true, state[stackKey].quantity ),
            bom: product.bom,
            bomItems:[... new Set(bomItemsNotConfigured)],
            configurableProduct: product.configurableProduct,
            deliveryOption:product.deliveryOption,
            noteByUser:state[stackKey].noteByUser || product.noteByUser || "",
            superCode:product.superCode,
            superCodeLSO:product.superCodeLSO,
            NST_description: product.NST_description,
            frameSizeValue: product.frameSizeValue ||  product.assignments && product.assignments.find(ass=>ass.name=="Variants.TAGLIA")?.value+'.2' 
          });
          if( hasAdditionalProducts ){
            if( product.additionalProducts && product.additionalProducts.length > 0){
              product.additionalProducts[0].name && productList.push({
                product: product.additionalProducts[0].name,
                quantity: product.additionalProducts[0].amount,
                importAccessories: getAccessoriesExtended( product.additionalProducts[0].configuration, [], true, true, product.additionalProducts[0].amount ),
              });
            }
          }
        }
      });
      localStore.set('cart', productList);
    } catch(err) {}
  }
  return state;
}

const clonedIdx = {};
const initialState = {};
const store = multiCartStore( createItemUuid );

export const cartReducer = ( state = initialState, action = {} ) => {
  switch ( action.type ) {
    case cartActions.ADD:
      return setItem(store.add( action.item, action.amount, action.options, null,action.noteByUser, state ));
    case cartActions.REMOVE:
      return setItem(store.remove( action.item, state ));
    case cartActions.SETAMOUNT:
      return setItem(store.setQuantity( action.item, action.amount, state ));
    case cartActions.UPDATE:
      return setItem(store.update( action.oldItem, action.item, state ));
    case cartActions.CLONE:
      let key = createItemUuid( { ...action.item, clonedIdx: '' } );
      if ( !clonedIdx[key] ) {
        clonedIdx[key] = 0;
      }
      let cIdx = ++clonedIdx[key];
      return setItem(store.add( { ...action.item, clonedIdx: cIdx,cartID:undefined }, action.amount, action.parameters, null,action.item.noteByUser, state ));
    case cartActions.RESET:
      return setItem({});
    case cartActions.ADDNOTE:  
      return setItem(store.setNote(action.item, action.note,state));
    default:
      return state;
  }
};